module.exports = __webpack_public_path__ + "img/icon6.24300df.webp";